import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import StreamPage from './StreamPage';

export default function StreamSubPageRoute() {
  const { pageSlug } = useParams();

  if (!pageSlug?.startsWith('stream-')) {
    return <Navigate to="/" replace />;
  }

  const slug = pageSlug.slice('stream-'.length);
  if (!slug) {
    return <Navigate to="/stream" replace />;
  }

  return <StreamPage slug={slug} />;
}
